import Avatar from '@zenbusiness/zui/Avatar';
import Box from '@zenbusiness/zui/Box';
import Card from '@zenbusiness/zui/Card';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

export const SocialProofContainer = superstyled({
  name: 'ZuiSocialProofContainer',
  slot: 'Root',
  tag: Stack,
  propsNeeded: ['testimonialHeight'],
  styles: ({ theme, testimonialHeight }) => ({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    gap: theme.spacing(3),
    paddingTop: theme.spacing(2),
    marginBottom: `${testimonialHeight}px`,

    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
      paddingTop: 0,
      marginBottom: 0
    }
  })
});

export const SocialProofImageContainer = superstyled({
  name: 'ZuiSocialProofImageContainer',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    overflow: 'hidden',
    borderRadius: theme.shape.rounded.xl,

    [theme.breakpoints.up('lg')]: {
      width: '52%'
    }
  })
});

export const SocialProofImage = superstyled({
  name: 'ZuiSocialProofImage',
  slot: 'Root',
  tag: SharedAsset,
  styles: ({ theme }) => ({
    width: '100%',
    minHeight: '10.75rem',
    overflow: 'hidden',

    [theme.breakpoints.up('lg')]: {
      height: 'auto',
      minHeight: '15.875rem',
      borderRadius: 0
    }
  })
});

export const TestimonialCard = superstyled({
  name: 'ZuiTestimonialCard',
  slot: 'Root',
  tag: Card,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: '100%',
    left: theme.spacing(2),
    right: theme.spacing(2),
    width: 'auto',
    transform: 'translateY(-28px)',
    gap: theme.spacing(3),
    backgroundColor: 'rgba(255, 255, 255, 0.93)',
    boxShadow: theme.shadows[3],
    border: 'none',

    [theme.breakpoints.up('lg')]: {
      top: 32,
      right: 0,
      left: 'unset',
      width: '52%',
      flexDirection: 'row',
      transform: 'none',
      backgroundColor: theme.palette.background.grey.light
    }
  })
});

export const AuthorAvatar = superstyled({
  name: 'ZuiAuthorAvatar',
  slot: 'Root',
  tag: Avatar,
  styles: ({ theme }) => ({
    width: '3rem',
    height: '3rem',
    backgroundColor: theme.palette.background.blue.light,

    [theme.breakpoints.up('lg')]: {
      width: '3.75rem',
      height: '3.75rem'
    }
  })
});

export const TestimonialContent = superstyled({
  name: 'ZuiTestimonialContent',
  slot: 'Root',
  tag: Stack,
  styles: ({ theme }) => ({
    gap: theme.spacing(2),

    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row'
    }
  })
});
